import { Stack } from '@mui/material';
import { ParagraphSkeletonProps, SKELETON_TEXT_HEIGHT } from '../Skeleton.types';
import { SkeletonText } from './SkeletonText';

export const ParagraphSkeleton = ({ sx }: ParagraphSkeletonProps) => {
    return (
        <Stack spacing={1} sx={sx}>
            <SkeletonText width={448} height={SKELETON_TEXT_HEIGHT} />
            <SkeletonText width={448} height={SKELETON_TEXT_HEIGHT} />
            <SkeletonText width={248} height={SKELETON_TEXT_HEIGHT} />
        </Stack>
    );
};
